
const defaultAttrs = {"viewBox":"0 0 24 24"};
const svgInner = "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M20.707 5.293a1 1 0 0 1 0 1.414l-11 11a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L9 15.586 19.293 5.293a1 1 0 0 1 1.414 0\" clip-rule=\"evenodd\"/>";

export default function CheckSvg(props = {}) {
  const className = props.className || props.class;
  const viewBox = defaultAttrs.viewBox;

  let attrs = 'xmlns="http://www.w3.org/2000/svg"';
  if (viewBox) attrs += ' viewBox="' + viewBox + '"';
  if (className) attrs += ' class="' + className + '"';
  if (props.width !== undefined) attrs += ' width="' + props.width + '"';
  if (props.height !== undefined) attrs += ' height="' + props.height + '"';

  return '<svg ' + attrs + '>' + svgInner + '</svg>';
}
